import React, { CSSProperties, memo } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';

export interface CardBoxProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  extraContent?: React.ReactNode;
  style?: CSSProperties;
  className?: string;
  titleType?: 'default' | 'simple';
  /** 标题右侧内容 */
  titleRight?: React.ReactNode;
}

const CardBox: React.FC<CardBoxProps> = ({
  title,
  children,
  extraContent,
  style,
  className,
  titleType = 'default',
  titleRight,
}) => {
  const showHeader = title || extraContent;

  return (
    <div className={styles.cardContainer} style={style}>
      {showHeader && (
        <div className={styles.headerWrapper}>
          <div className={styles.titleArea}>
            {title ? (
              titleType === 'default' ? (
                <div className={styles.formTitle}>{title}</div>
              ) : (
                <div className={styles.simpleTitle}>{title}</div>
              )
            ) : (
              <div />
            )}
            {titleRight && <span className={styles.titleRight}>{titleRight}</span>}
          </div>
          {extraContent ? extraContent : <div />}
        </div>
      )}
      <div className={classNames(styles.content, className)}>{children}</div>
    </div>
  );
};

export default memo(CardBox);
